import { gql } from "@apollo/client";

export const PROCESAR_FACTURAS = gql`
mutation procesarFacturas($mes: Int!, $anio: Int!) {
    procesarFacturas(mes: $mes, anio: $anio){
        success
        valorEsperado
        error
    }
}`;